import React from 'react'
import usePortManager from '../hooks/use-port-manager'
import { observer } from 'mobx-react'

function getPortStyle () {

  const portManager = usePortManager()

  const [cssHeight, cssWidth] = portManager.getPortCSSHeightAndWidth()
  const cssColor = getPortCSSColor()

  return {
    width: cssWidth + '%',
    height: cssHeight + '%',
    backgroundColor: cssColor,
  }
}

function getPortBorderTopStyle () {
  const portManager = usePortManager()

  const portHeight = portManager.getPortHeight()

  const borderTop = (2.5 / portHeight) * 100

  return { height: borderTop + '%' }
}

function getPortBorderBottomStyle () {
  const portManager = usePortManager()

  const portHeight = portManager.getPortHeight()

  const borderTop = (5 / portHeight) * 100

  return { height: borderTop + '%' }
}

function getPortBackgroundImageStyle () {
  const portManager = usePortManager()

  let model = portManager.getValue('model')

  if (typeof model === 'undefined') {
    model = 9000
  }

  const portHeight = portManager.getPortHeight()

  const base_url = window.main_theme_objects.assets_url
  const backgroundHeight = (500 / portHeight) * 100

  const backgroundImageSrc = base_url + 'port-images/port/background_' + model + '.png'

  return {
    backgroundImage: 'url(\'' + backgroundImageSrc + '\')',
    backgroundSize: '1px ' + backgroundHeight + '%'
  }
}

function getPortCSSColor () {
  const port_manager = usePortManager()
  const hex = require('ral-to-hex')

  let color

  try {
    color = hex(port_manager.getValue('color'))
  } catch (e) {
    color = 'rgb(256, 256, 256)'
  }

  return color
}

function Port (props) {
  return (
    <div className={'port_wrapper'} style={getPortStyle()}>
      <div className={'border_top'} style={getPortBorderTopStyle()}></div>
      <div className={'border_bottom'} style={getPortBorderBottomStyle()}></div>
      <div className={'background'} style={getPortBackgroundImageStyle()}></div>
      {props.children}
    </div>
  )
}

export default observer(Port)